<div *ngIf="dialogService.dialogContent$ | async as content" class="overlay" (click)="onOverlayClick()">
  <inka-dialog-container class="dialog-container" [content]="content" (click)="stopPropagation($event)">
  </inka-dialog-container>
</div>
